var chunkToChildrenMap = {
	"1425": [
		8033
	],
	"4465": [
		4174
	],
	"9869": [
		8033
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));